import { FormEventHandler } from 'react'
import { ObjectProperties } from '../../shared/types'
import { Button } from '../components/button'
import { useFormLayout } from '../layouts'
import { FormLayout } from '../layouts/form-layout'

type Props = {
	object: string
	data?: ObjectProperties
	onSubmit: FormEventHandler<HTMLFormElement>
	isPending?: boolean
}

export function ObjectForm({ object, data, onSubmit, isPending }: Props) {
	const { layout } = useFormLayout(object)

	return (
		<form
			className="m-auto max-w-[60em] bg-white rounded-xl border border-slate-200"
			onSubmit={onSubmit}
		>
			<div className="flex items-center justify-between gap-4 px-3 py-3 sm:px-5 sm:py-4">
				<h3 className="text-md font-bold">
					{data?.id ? 'Editace záznamu' : 'Nový záznam'}
				</h3>
			</div>
			<div className="px-3 py-3 sm:px-5 sm:py-4 space-y-4">
				<FormLayout layout={layout} data={data} />
				<Button type="submit" isPending={isPending} isDisabled={isPending}>
					Uložit
				</Button>
			</div>
		</form>
	)
}
